import React, { useState, useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';
import { MdCenterFocusStrong, MdZoomIn, MdZoomOut } from 'react-icons/md';

// --- STÍLUSOK (FELÜLRE MOZGATVA A TDZ ELKERÜLÉSE ÉRDEKÉBEN) ---
const containerStyle = { padding: '15px', maxWidth: '500px', margin: '0 auto', fontFamily: 'sans-serif' };

const scannerWrapperStyle = { position: 'relative', width: '100%', borderRadius: '16px', overflow: 'hidden', backgroundColor: '#000', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' };

const readerStyle = {
    width: '100%',
    minHeight: '250px',
    backgroundColor: '#000'
};

const hintStyle = {
    position: 'absolute',
    top: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(179, 0, 0, 0.8)',
    color: 'white',
    padding: '5px 12px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    zIndex: 15,
    pointerEvents: 'none'
};

const controlsOverlayStyle = { position: 'absolute', bottom: '15px', left: 0, right: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', zIndex: 10 };

const rightSideOverlayStyle = {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.4)',
    padding: '10px 4px',
    borderRadius: '15px',
    zIndex: 20
};

const verticalSliderStyle = {
    appearance: 'slider-vertical',
    WebkitAppearance: 'slider-vertical',
    width: '12px',
    height: '100px',
    accentColor: '#4CAF50',
    cursor: 'pointer'
};

const zoomControlStyle = { display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'rgba(0,0,0,0.5)', padding: '8px 15px', borderRadius: '20px', width: '80%' };

const sliderStyle = { flex: 1, accentColor: '#b30000' };

const roundBtnStyle = { width: '50px', height: '50px', borderRadius: '25px', border: 'none', backgroundColor: 'rgba(179, 0, 0, 0.8)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' };

const listContainerStyle = { marginTop: '20px', backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '12px', border: '1px solid #eee' };

const itemStyle = { display: 'flex', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eee' };

const removeButtonStyle = { backgroundColor: '#ffebee', color: '#c62828', border: '1px solid #ef9a9a', padding: '4px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer' };

const startButtonStyle = { width: '100%', backgroundColor: '#b30000', color: 'white', border: 'none', padding: '16px', borderRadius: '12px', marginTop: '20px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer', boxShadow: '0 4px 10px rgba(179,0,0,0.3)' };

const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 3000 };

const modalContentStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '20px', width: '280px', textAlign: 'center' };

const inputStyle = { width: '80px', padding: '12px', fontSize: '20px', textAlign: 'center', borderRadius: '10px', border: '2px solid #ddd', outline: 'none' };

const confirmButtonStyle = { flex: 1, backgroundColor: '#b30000', color: 'white', border: 'none', padding: '12px', borderRadius: '10px', fontWeight: 'bold' };

const cancelButtonStyle = { flex: 1, backgroundColor: '#f5f5f5', color: '#666', border: 'none', padding: '12px', borderRadius: '10px' };


const QrScannerWeb = () => {
    const [scannedCompetitors, setScannedCompetitors] = useState([]);
    const [showTargetModal, setShowTargetModal] = useState(false);
    const [startingTarget, setStartingTarget] = useState(1);
    const [zoom, setZoom] = useState(1);
    const [brightness, setBrightness] = useState(100);
    const [capabilities, setCapabilities] = useState(null);
    const [isScannerStarted, setIsScannerStarted] = useState(false);

    const scannerRef = useRef(null);
    const lastScanTimeRef = useRef(0);
    const navigate = useNavigate();

    useEffect(() => {
        let isMounted = true;
        const html5QrCode = new Html5Qrcode("reader");
        scannerRef.current = html5QrCode;

        // Rövid várakozás a biztonságos indításhoz (React Strict Mode védelem)
        const timer = setTimeout(() => {
            if (isMounted) {
                startScanner();
            }
        }, 300);

        return () => {
            isMounted = false;
            clearTimeout(timer);
            if (scannerRef.current && scannerRef.current.isScanning) {
                scannerRef.current.stop().catch(err => console.error("Stop failed", err));
            }
        };
    }, []);

    const startScanner = async () => {
        if (!scannerRef.current) return;

        try {
            const config = {
                fps: 25,
                qrbox: (viewfinderWidth, viewfinderHeight) => {
                    const minEdge = Math.min(viewfinderWidth, viewfinderHeight);
                    // Kisebb négyzet (0.55), hogy távolabb kényszerítsük a telefont a fókusz miatt
                    const edgeSize = Math.max(Math.floor(minEdge * 0.55), 150);
                    return { width: edgeSize, height: edgeSize };
                },
                aspectRatio: 1.0,
                experimentalFeatures: {
                    useBarCodeDetectorIfSupported: true
                }
            };

            // EGYSZERŰSÍTETT INDÍTÁS: Csak alapbeállítások
            await scannerRef.current.start(
                { facingMode: "environment" },
                config,
                onScanSuccess
            );

            setIsScannerStarted(true);

            // Csak a kontraszt szűrőt tartjuk meg, manuális méretezés nélkül
            setTimeout(() => {
                const videoElement = document.querySelector("#reader video");
                if (videoElement) {
                    videoElement.style.filter = "contrast(1.2) brightness(0.9)";
                }
            }, 1000);

            const videoTrack = scannerRef.current.getRunningTrack();
            if (videoTrack) {
                const caps = videoTrack.getCapabilities();
                setCapabilities(caps);

                const constraints = { advanced: [{ focusMode: 'continuous' }] };

                // Expozíció csökkentése az LCD fényereje ellen, ha támogatott
                if (caps.exposureCompensation) {
                    constraints.advanced.push({ exposureCompensation: caps.exposureCompensation.min });
                }

                await videoTrack.applyConstraints(constraints);
            }
        } catch (err) {
            if (err.toString().includes("NotReadableError") || err.toString().includes("already scanning")) {
                return;
            }
            console.error("Kamera indítási hiba:", err);
            try {
                await scannerRef.current.start({ facingMode: "environment" }, { fps: 10 }, onScanSuccess);
                setIsScannerStarted(true);
            } catch (e) {}
        }
    };

    const audioCtxRef = useRef(null);

    // Hangrendszer beélesítése (user interaction kell hozzá)
    const initAudio = () => {
        if (!audioCtxRef.current) {
            audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
        }
        if (audioCtxRef.current.state === 'suspended') {
            audioCtxRef.current.resume();
        }
    };

    const playBeep = () => {
        try {
            initAudio(); // Minden próbálkozásnál megpróbáljuk ébreszteni
            const ctx = audioCtxRef.current;
            const oscillator = ctx.createOscillator();
            const gainNode = ctx.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(ctx.destination);

            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(880, ctx.currentTime);
            gainNode.gain.setValueAtTime(0, ctx.currentTime);
            gainNode.gain.linearRampToValueAtTime(0.2, ctx.currentTime + 0.01);
            gainNode.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.2);

            oscillator.start(ctx.currentTime);
            oscillator.stop(ctx.currentTime + 0.2);
        } catch (e) {
            console.error("Audio hiba", e);
        }
    };

    const onScanSuccess = (decodedText) => {
        const now = Date.now();
        if (now - lastScanTimeRef.current < 2000) return;

        processQrString(decodedText);
        lastScanTimeRef.current = now;
    };

    const handleZoomChange = async (e) => {
        const value = parseFloat(e.target.value);
        setZoom(value);
        if (scannerRef.current && scannerRef.current.getState() === 2) {
            const videoTrack = scannerRef.current.getRunningTrack();
            if (videoTrack) {
                try {
                    await videoTrack.applyConstraints({
                        advanced: [{ zoom: value }]
                    });
                } catch (err) {
                    console.error("Zoom hiba", err);
                }
            }
        }
    };

    const refocus = async () => {
        try {
            if (scannerRef.current && scannerRef.current.getState() === 2) {
                const videoTrack = scannerRef.current.getRunningTrack();
                if (videoTrack) {
                    const currentZoom = zoom;
                    // Dupla rántás a biztos fókuszért
                    const kick = async (z) => {
                        await videoTrack.applyConstraints({ advanced: [{ zoom: z }] });
                        return new Promise(r => setTimeout(r, 100));
                    };

                    const maxZ = capabilities?.zoom?.max || 2;
                    const tempZ = currentZoom + 0.5 <= maxZ ? currentZoom + 0.5 : currentZoom - 0.5;

                    await kick(tempZ);
                    await kick(currentZoom);

                    // Végül kényszerített folyamatos mód
                    await videoTrack.applyConstraints({ advanced: [{ focusMode: 'continuous' }] });
                }
            }
        } catch (err) {
            console.warn("Fókuszálási hiba:", err);
        }
    };

    const handleBrightnessChange = (e) => {
        const value = parseInt(e.target.value);
        setBrightness(value);
        const videoElement = document.querySelector("#reader video");
        if (videoElement) {
            // Kombinált szűrő: az alap kontraszt mellé tesszük a változtatható fényerőt
            videoElement.style.filter = `contrast(1.2) brightness(${value / 100})`;
        }
    };

    const processQrString = (qrDataString) => {
        const parts = qrDataString.split(';');
        if (parts.length === 9) {
            try {
                const competitorId = parts[2].trim();
                const name = parts[3].trim();
                const bowCategory = parts[4].trim();
                const shotsPerTarget = parseInt(parts[8].trim());

                setScannedCompetitors(prev => {
                    if (prev.find(c => c.competitorId === competitorId)) return prev;

                    // Új versenyző esetén lejátszunk egy csippanást
                    playBeep();

                    const newCompetitor = {
                        competitorId: competitorId,
                        competitorName: name,
                        rawPossibleHitValuesString: parts[0].trim(),
                        bowCategory: bowCategory,
                        ageCategory: parts[5].trim(),
                        gender: parseInt(parts[6].trim()),
                        targetCount: parseInt(parts[7].trim()),
                        shotsPerTarget: shotsPerTarget
                    };
                    return [...prev, newCompetitor];
                });
            } catch (e) {
                console.error("QR parzolási hiba", e);
            }
        }
    };

    const removeCompetitor = (id) => {
        setScannedCompetitors(prev => prev.filter(c => c.competitorId !== id));
    };

    const confirmStart = () => {
        localStorage.setItem('temp_competition_competitors', JSON.stringify(scannedCompetitors));
        localStorage.setItem('temp_competition_starting_target', startingTarget);
        localStorage.removeItem('competition_scoring_session');
        navigate('/competition-scoring-web');
    };

    return (
        <div style={containerStyle} onClick={initAudio} onTouchStart={initAudio}>
            <h2 style={{ textAlign: 'center', color: '#b30000', marginBottom: '20px' }}>Pro QR Olvasó</h2>

            <div style={scannerWrapperStyle}>
                <div id="reader" style={readerStyle}></div>

                {/* Figyelmeztetés */}
                {isScannerStarted && (
                    <div style={hintStyle}>NE VIDD TÚL KÖZEL! INKÁBB ZOOMOLJ!</div>
                )}

                {/* Kamera vezérlők */}
                {isScannerStarted && (
                    <>
                        <div style={controlsOverlayStyle}>
                            {capabilities?.zoom && (
                                <div style={zoomControlStyle}>
                                    <MdZoomOut color="white" />
                                    <input
                                        type="range"
                                        min={capabilities.zoom.min}
                                        max={capabilities.zoom.max}
                                        step="0.1"
                                        value={zoom}
                                        onChange={handleZoomChange}
                                        style={sliderStyle}
                                    />
                                    <MdZoomIn color="white" />
                                </div>
                            )}

                            {/* Fókusz gomb újra középen */}
                            <button onClick={refocus} style={roundBtnStyle} title="Fókusz újra">
                                <MdCenterFocusStrong size={24} />
                            </button>
                        </div>

                        {/* Függőleges fényerő csúszka a jobb oldalon */}
                        <div style={rightSideOverlayStyle}>
                            <span style={{color:'white', fontSize: '9px', fontWeight: 'bold', marginBottom: '5px'}}>FÉNY</span>
                            <input
                                type="range"
                                min="20"
                                max="150"
                                value={brightness}
                                onChange={handleBrightnessChange}
                                style={verticalSliderStyle}
                            />
                        </div>
                    </>
                )}
            </div>

            <div style={listContainerStyle}>
                <h3 style={{ fontSize: '16px', borderBottom: '1px solid #ddd', paddingBottom: '8px', display: 'flex', justifyContent: 'space-between' }}>
                    <span>Csapat tagjai</span>
                    <span style={{ color: '#b30000' }}>{scannedCompetitors.length} fő</span>
                </h3>
                {scannedCompetitors.length === 0 ? (
                    <p style={{ color: '#888', textAlign: 'center', padding: '10px' }}>Még nem olvastál be senkit.</p>
                ) : (
                    <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                        {scannedCompetitors.map(c => (
                            <div key={c.competitorId} style={itemStyle}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{c.competitorName}</div>
                                    <div style={{ fontSize: '11px', color: '#666' }}>{c.bowCategory} • {c.targetCount} cél</div>
                                </div>
                                <button onClick={() => removeCompetitor(c.competitorId)} style={removeButtonStyle}>Törlés</button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <button
                onClick={() => scannedCompetitors.length > 0 && setShowTargetModal(true)}
                style={{...startButtonStyle, opacity: scannedCompetitors.length > 0 ? 1 : 0.5}}
            >
                Verseny Indítása
            </button>

            {/* Kezdő cél modal */}
            {showTargetModal && (
                <div style={modalOverlayStyle}>
                    <div style={modalContentStyle}>
                        <h4 style={{ margin: '0 0 15px 0' }}>Kezdő cél sorszáma?</h4>
                        <input
                            type="number"
                            value={startingTarget}
                            onChange={(e) => setStartingTarget(parseInt(e.target.value))}
                            min="1"
                            style={inputStyle}
                        />
                        <div style={{ display: 'flex', gap: '10px', marginTop: '25px' }}>
                            <button onClick={() => setShowTargetModal(false)} style={cancelButtonStyle}>Mégse</button>
                            <button onClick={confirmStart} style={confirmButtonStyle}>Mehet!</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default QrScannerWeb;
